import { PagedRepeat } from "lib/@components/paged-repeat"

import { ReportRow } from "routes/sfg20-admin/plugins/system-info/reports-tab/report-row"
import { DownloadButton } from "routes/sfg20-admin/plugins/system-info/common/components/download-button"

export function ReportByClientItem({ item, columns, title }) {
    let list
    const values = Object.values(item)
    values.forEach((value) => {
        if (Array.isArray(value)) list = value
    })

    return (
        <>
            <PagedRepeat list={list} item={<ReportRow columns={columns} />} />
            <DownloadButton data={{ value: list }} title={title} columns={columns} />
        </>
    )
}
